import { createFileRoute } from "@tanstack/react-router";

// Route metadata only. Component lives in `$routeId.lazy.tsx`.
//
// This is the canonical URL for a single route — `/app/routes/{routeId}`.
// The nested `/app/sources/{sourceId}/routes/{routeId}/mapping` URL also
// exists (and continues to work for backwards compatibility), but new links
// from anywhere in the app target this first-class location. Sources
// "contain" routes in the UI, but routes are top-level entities in the data
// model and deserve a top-level URL space too.
export const Route = createFileRoute("/app/routes/$routeId")({});
